"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotificationMessagesSelectors = exports.NotificationMessagesAccessors = void 0;
var NotificationMessagesAccessors = /** @class */ (function () {
    function NotificationMessagesAccessors() {
    }
    NotificationMessagesAccessors.getAppNotificationMessages = function (state) { return state.notificationMessages; };
    return NotificationMessagesAccessors;
}());
exports.NotificationMessagesAccessors = NotificationMessagesAccessors;
var NotificationMessagesSelectors = /** @class */ (function () {
    function NotificationMessagesSelectors() {
    }
    return NotificationMessagesSelectors;
}());
exports.NotificationMessagesSelectors = NotificationMessagesSelectors;
